export const commonTags = {
    medical: [
        'Blood Pressure',
        'Medications',
        'Lab Results',
        'Symptoms',
        'Doctor Visit',
        'Diagnosis',
        'Treatment',
        'Vital Signs'
    ],
    careCoordination: [
        'Equipment',
        'Referral',
        'Authorization',
        'Documentation',
        'Coordination',
        'Planning',
        'Scheduling',
        'Follow-up'
    ],
    activities: [
        'Exercise',
        'Diet',
        'Therapy',
        'Physical Therapy',
        'Social',
        'Recreation',
        'Cognitive',
        'Speech Therapy'
    ],
    dailyCare: [
        'Hygiene',
        'Mobility',
        'Safety',
        'Meals',
        'Sleep',
        'Medication',
        'Comfort',
        'Transfer'
    ]
};

// Get all common tags as a flat array
export const getAllCommonTags = (): string[] => {
    return [
        ...commonTags.medical,
        ...commonTags.careCoordination,
        ...commonTags.activities,
        ...commonTags.dailyCare
    ];
};

// Get category for a tag
export const getTagCategory = (tag: string): string | undefined => {
    for (const [category, tags] of Object.entries(commonTags)) {
        if (tags.includes(tag)) {
            return category;
        }
    }
    return undefined;
};
